import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import InvoiceLimitBanner from '../components/InvoiceLimitBanner';
import { UserContext } from '../context/UserContext';
import { Button, UserManagementTable, btnSecondary } from '@redpanda/ui';
import { formatTableDate } from '@redpanda/utils';
import { getApprovedUsers, getPendingUsers, updateUserRole, deleteUser, approveUser, rejectUser } from '../services/api';
import { isSubscriptionEnabled } from '../utils/environment';

// 使用者管理表（@redpanda/ui 共用，R26）呼叫的 API
const userManagementApi = { getApprovedUsers, getPendingUsers, updateUserRole, deleteUser, approveUser, rejectUser };

/** 管理員面板（路由限 SUPER_ADMIN，App.tsx；照 CRM） */
const AdminPage: React.FC = () => {
  const { t } = useTranslation();
  const userContext = useContext(UserContext);
  const navigate = useNavigate();

  return (
    <div className="container mx-auto px-10 py-6 pb-32">
      <h1 className="text-2xl font-semibold text-gray-900 dark:text-white mb-6">{t('admin.title')}</h1>

      <InvoiceLimitBanner showAlways={true} />

      <div className="mb-8">
        <h2 className="text-base font-semibold text-fg mb-3">{t('admin.userManagement')}</h2>
        <UserManagementTable api={userManagementApi} currentUser={userContext?.user} formatDate={formatTableDate} />
      </div>

      {/* 兩個入口：一個容器＋細線分隔；按鈕都是次要（同一區塊不放兩顆主色） */}
      <div className="grid grid-cols-1 md:grid-cols-2 bg-surface rounded-lg border border-line divide-y md:divide-y-0 md:divide-x divide-line">
        <section className="p-5">
          <h2 className="text-base font-semibold text-fg mb-1">{t('admin.dataManagementTitle')}</h2>
          <p className="text-sm text-fg-secondary mb-4">{t('admin.dataManagementDescription')}</p>
          <Button variant="secondary" onClick={() => navigate('/data-io')}>
            {t('admin.goToDataIO')}
          </Button>
        </section>

        {isSubscriptionEnabled() && (
          <section className="p-5">
            <h2 className="text-base font-semibold text-fg mb-1">{t('admin.subscriptionManagement')}</h2>
            <p className="text-sm text-fg-secondary mb-4">{t('admin.subscriptionDescription')}</p>
            <a
              href={`${process.env.REACT_APP_ACCOUNT_PORTAL_URL || 'http://localhost:8003'}/accounting`}
              target="_blank"
              rel="noopener noreferrer"
              className={btnSecondary}
            >
              {t('common.navigation.manageSubscription')}
            </a>
          </section>
        )}
      </div>
    </div>
  );
};

export default AdminPage;
